import React from 'react';

const Experience = () => {
  return (
    <div>
      <section className="colorlib-experience" data-section="experience">
        <div className="colorlib-narrow-content">
          <div className="row">
            <div
              className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
              data-animate-effect="fadeInLeft"
            >
              <span className="heading-meta">highlights</span>
              <h2 className="colorlib-heading animate-box">Experience</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="timeline-centered">
                <article
                  className="timeline-entry animate-box"
                  data-animate-effect="fadeInTop"
                >
                  <div className="timeline-entry-inner">
                    <div className="timeline-icon">
                      <img src="/images/MAKLogo.jpg" alt=""></img>
                    </div>
                    <div className="timeline-label">
                      <h2>
                        Student Developer Intern{' '}
                        <span>April 2019 - To date</span>
                      </h2>
                      <a href="http://staging.cranecloud.io/" target="_blank" rel="noreferrer noopener">

                        {' '}
                        <span>
                          Crane Cloud  -
                          Kampala, Uganda
                        </span>
                      </a>
                      <br />
                      <br />
                      <ul>
                        <li>
                          Been part of the back-end team and have contributed to developing a python based <a href="https://github.com/crane-cloud/backend">Flask Restful API</a>  for  <a href="http://staging.cranecloud.io/">Crane Cloud</a>
                        </li>
                        <li>
                          Worked with the front-end team to develop a <a href="https://github.com/crane-cloud/frontend">ReactJS application</a>  for Crane Cloud.
                        </li>
                        <li>
                          Worked with tools like Prometheus and Grafana to carry out kubernetes cluster monitoring.
                        </li>
                      </ul>
                    </div>
                  </div>
                </article>
                <article
                  className="timeline-entry animate-box"
                  data-animate-effect="fadeInLeft"
                >
                  <div className="timeline-entry-inner">
                    <div className="timeline-icon">
                      <img src="/images/MAKLogo.jpg" alt="MAK Logo"></img>{' '}
                    </div>
                    <div className="timeline-label">
                      <h2>
                        Team Player In Hackthons(Volunteer){' '}
                        <span>March 2020 - To date</span>
                      </h2>
                      <a href="" target="_blank" rel="noreferrer noopener">
                        {' '}
                        <span>
                          Took part in a number of covid 19 tech challenges
                        </span>
                      </a>
                      <br />
                      <br />
                      <ul>
                        <li>
                          This has sofar been a trying moment for the world that was hit with a covid 19 pandemic thus sending the majority of the countries into lock down. But as a developer, i have used this time to team us with colleagues and innovate solutions to help the African communities. I have taken part in building a chatbot project aimed at creating awareness about covid19 to people in their native languages. It can be accessed here <a href="https://covid19.mfeyti.com/">https://covid19.mfeyti.com/</a> . In this same period i have taken part in a number of exciting competitions and hackathons like coding contest 2020, AfricaVsVirus , smarterthancora .

                        </li>
                        <li>
                          Took part in Andela and Facebook's Build4SDG challenge 2020, where i was elected product manager in my team for the Slum Data Project. 
                        </li>
                        <li>I also took part in the MIT Covid19 challenge <a href="https://covid19challenge.mit.edu/africa-takes-on-covid19/">https://covid19challenge.mit.edu/africa-takes-on-covid19/</a> , under Track B. Here my team built a prototype to strenthen the referral system by embracing Telemedicine to bridge the gap between health workers and the general public.</li>
                      </ul>
                    </div>
                  </div>
                </article>
                <article
                  className="timeline-entry animate-box"
                  data-animate-effect="fadeInLeft"
                >
                  <div className="timeline-entry-inner">
                    <div className="timeline-icon">
                      <img src="/images/MAKLogo.jpg" alt="MAK Logo"></img>{' '}
                    </div>
                    <div className="timeline-label">
                      <h2>
                       PHP Web Developer (Intern){' '}
                        <span>December 2019 - March 2020</span>
                      </h2>
                      <a href="http://wids.mak.ac.ug/wids/" target="_blank" rel="noreferrer noopener">
                        {' '}
                        <span>
                          WIMEA ICT (COCIS) -
                          Makerere University
                        </span>
                      </a>
                      <br />
                      <br />
                      <ul>
                        <li>
                          Contributed to developing the Weather information Disseminimation System <a href="http://wids.mak.ac.ug/wids/">(WIDs)</a>. It is aimed at making it easy for everyone to access weather information in Uganda.
                        </li>
                        <li>
                          I also helped in creating awareness of the product among the public.
                        </li>
                      </ul>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Experience;
